class CAMCRetirementTabs {
    constructor(container = null) {
        this.$container = $(container);
        this.init();
    }

    init() {
        this.bindEvents();
        this.setInitialActiveTab();
    }

    bindEvents() {
        this.$container.on("click", ".fil-chip--multiselect", this.handleTabClick.bind(this));
    }

    handleTabClick(e) {
        e.preventDefault();

        var $clickedTab = $(e.currentTarget);
        var targetTabId = $clickedTab.attr("tab-id");

        // Remove selected class and set data-active to false for all tabs and content
        this.$container.find(".fil-chip--multiselect").removeClass("fil-chip--selected").attr("data-active", "false");
        this.$container.find(".camc-retirement-tab__content").removeClass("active").attr("data-active", "false");

        // Add selected class and set data-active to true for clicked tab
        $clickedTab.addClass("fil-chip--selected").attr("data-active", "true");

        // Find and show the corresponding tab content using the tab-id
        var $targetContent = this.$container.find("#" + targetTabId);
        $targetContent.addClass("active").attr("data-active", "true");
    }

    setInitialActiveTab() {
        // Initialize based on data-active attributes
        this.$container.find(".fil-chip--multiselect").each(function () {
            var $tab = $(this);
            if ($tab.attr("data-active") === "true") {
                $tab.addClass("fil-chip--selected");
            } else {
                $tab.removeClass("fil-chip--selected");
            }
        });

        this.$container.find(".camc-retirement-tab__content").each(function () {
            var $content = $(this);
            if ($content.attr("data-active") === "true") {
                $content.addClass("active");
            } else {
                $content.removeClass("active");
            }
        });
    }
}

export default CAMCRetirementTabs;
